import { Text } from '@fluentui/react-northstar';
import React from 'react';

export const Title = ({ text }) => (
  <Text size="small" style={{ color: '#8f90a6', marginLeft: '4px' }}>
    {text}:
  </Text>
);
